import { Allergens } from 'fitbeat.models';
import React from 'react';
import {
  StyleSheet, Text, TextStyle, View,
} from 'react-native';
import { Switch } from '../../ui/components/Switch';
import theme from '../../theme';
import { allergens } from '../../utils/allergens';
import { defaultScale } from '../../utils/scaling';

interface IProps {
  onSelected: (allergen: Allergens) => void;
  onUnselected: (allergen: Allergens) => void;
  selectedAllergens: Allergens[];
  textStyle?: TextStyle;
}

export const AllergenPreference: React.FC<IProps> = ({
  onSelected,
  onUnselected,
  selectedAllergens,
  textStyle,
}) => (
  <>
    {allergens.map((allergen) => {
      const isSelected = selectedAllergens.includes(allergen.value);
      return (
        <View key={allergen.title} style={styles.iconLabelSwitchContainer}>
          <View style={styles.iconLabelContainer}>
            <Text style={[theme.textStyle.bodyCopyReg, styles.allergenText, textStyle]}>
              {allergen.title}
            </Text>
          </View>
          <Switch
            onValueChange={(toggledOn: boolean) => {
              if (toggledOn) {
                onSelected(allergen.value);
                return;
              }
              onUnselected(allergen.value);
            }}
            value={isSelected}
          />
        </View>
      );
    })}
  </>
);

const styles = StyleSheet.create({
  iconLabelSwitchContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    height: defaultScale(64),
    borderBottomWidth: 1,
    borderColor: theme.GREY_LIGHT,
    justifyContent: 'space-between',
  },
  iconLabelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  allergenText: {
    ...theme.textStyle.bodyCopyReg,
    fontSize: defaultScale(14),
  },
});
